// Magnetic buttons: the rose buttons (.button--solid without another look) lean towards a mouse over them, at most
// 3 px, their arrow a little further, and ease back when it leaves (--mx/--my, components/_motion.scss). Only for
// a mouse on a device that can hover; not with reduced motion. The button moves less than its own padding, so it
// stays under the pointer and easy to hit.
import { reducedMotion } from './motion.js'

const SELECTOR = '.button--solid:not(.button--border, .button--dark, .button--text, .button--light, .button--pill)'
const PULL = 0.12 // share of the pointer's distance from the centre (Lars found 0.3 / 6 px too strong)
const MAX = 3 // px

export function initMagnetic() {
	const fine = window.matchMedia('(hover: hover) and (pointer: fine)')

	document.querySelectorAll(SELECTOR).forEach((button) => {
		let x = 0
		let y = 0
		const set = (nx, ny) => {
			x = nx
			y = ny
			button.style.setProperty('--mx', `${x.toFixed(2)}px`)
			button.style.setProperty('--my', `${y.toFixed(2)}px`)
		}

		button.addEventListener('pointermove', (event) => {
			if (event.pointerType !== 'mouse' || !fine.matches || reducedMotion.matches) return
			// the box without the current lean, so the button does not chase itself
			const box = button.getBoundingClientRect()
			const cx = box.left - x + box.width / 2
			const cy = box.top - y + box.height / 2
			const clamp = (v) => Math.max(-MAX, Math.min(MAX, v))
			button.classList.add('is-magnet')
			set(clamp((event.clientX - cx) * PULL), clamp((event.clientY - cy) * PULL))
		})
		button.addEventListener('pointerleave', () => {
			button.classList.remove('is-magnet')
			set(0, 0)
		})
	})
}
